import { useEffect, useState } from 'react';
import { Login } from './pages/Login';
import { Chat } from './pages/Chat';
import { useViewportHeight } from './lib/viewport';

export function App() {
  const [authed, setAuthed] = useState<boolean | null>(null);

  useViewportHeight();

  useEffect(() => {
    fetch('/api/auth/me')
      .then((r) => setAuthed(r.ok))
      .catch(() => setAuthed(false));
  }, []);

  if (authed === null) return null;
  if (!authed) return <Login onSuccess={() => setAuthed(true)} />;
  return <Chat onLogout={() => setAuthed(false)} />;
}
